<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="warningPlan">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 预警方案管理
        </span>
        <div class="w_normalNav">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <button class="GreenSmBtn" @click="addnew">新增</button>
        </div>
        <div class="searchForm1">
          <el-form ref="seefrom" class="uLabelDcontent" :model="searchForm">
            <el-form-item label="方案名称:">
              <el-input v-model="searchForm.name" placeholder="请输入名称"></el-input>
            </el-form-item>
            <el-form-item label="预警系统:">
              <el-select :popper-append-to-body="false" v-model="searchForm.warnSysId" placeholder="请选择预警系统" style="width:100%" clearable>
                <el-option v-for="item in systemList" :key="item.id" :label="item.warningSystemName" :value="item.warningSystemId"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="tableWrapper">
          <el-table :data="tableData" style="width: 100%" class="stripeTable" height="500" ref="Table">
            <el-table-column show-overflow-tooltip :label="label" :prop="prop" :align="align" v-for="({prop,label,align}) in config" :key="prop.toString()"></el-table-column>
            <el-table-column label="操作" width="310">
              <template slot-scope="scope">
                <el-link icon="iconfont iconcheck" type="text" size="small" @click="check(scope.row)">查看</el-link>
                <el-link icon="iconfont iconedit" type="text" size="small" @click="edit(scope.row)">修改</el-link>
                <el-link icon="iconfont icontingyong" type="text" size="small" v-if="scope.row.status == 0" @click="operation(scope.row)">停用</el-link>
                <el-link icon="iconfont iconcheck1" type="text" size="small" v-if="scope.row.status == 1" @click="operation(scope.row)">启用</el-link>
                <el-link icon="iconfont icondelete" type="text" size="small" @click="deleteMsg(scope.row)" v-if="scope.row.status != 0">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="footer">
            <el-pagination layout="prev, pager, next" :page-size="10" @current-change="handleCurrentChange" :total="nTotal" :current-page="currentPage"></el-pagination>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <warning-plan-dialog v-model="planDialog" :status="addStatus" :data="detailData" @refresh="getTableData"></warning-plan-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabName: 'warningPlan',
      searchForm: {},
      nTotal: 0,
      currentPage: 1,
      systemList: [],
      tableData: [],
      planDialog: false,
      addStatus: 'adding',
      detailData: {}
    }
  },
  components: {
    warningPlanDialog: () => import('./warningPlanDialog')
  },
  computed: {
    config() {
      return [
        {
          prop: 'name',
          label: '方案名称'
        },
        {
          prop: 'warnSysName',
          label: '预警系统'
        },
        {
          prop: 'createTime',
          label: '创建时间'
        },
        {
          prop: 'statusName',
          label: '状态'
        }
      ]
    }
  },
  methods: {
    getOptions() {
      this.$axiosget('manager/warningSystem/company', {
        params: {
          companyId: localStorage.getItem('companyId')
        }
      }).then((res) => {
        this.systemList = res.data.data
      })
    },
    subSeefrom() {
      this.currentPage = 1
      this.getTableData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getTableData()
    },
    getTableData() {
      this.$axiosget('operation/advancedScheme/page', {
        params: {
          pageSize: 10,
          pageNum: this.currentPage,
          ...this.searchForm
        }
      }).then((res) => {
        this.tableData =
          res.data.data.list.length > 0
            ? res.data.data.list.map((item) => {
                return {
                  ...item,
                  statusName: item.status == 1 ? '未启用' : '启用'
                }
              })
            : []
        this.nTotal = res.data.data.total
      })
    },
    reset() {
      this.searchForm = {}
    },
    addnew() {
      this.addStatus = 'adding'
      this.planDialog = true
    },
    check(row) {
      this.detailData = row
      this.addStatus = 'readonly'
      this.planDialog = true
    },
    edit(row) {
      let data = _.cloneDeep(row)
      this.detailData = data
      this.addStatus = 'editing'
      this.planDialog = true
    },
    operation(row) {
      let mag, status
      if (row.status == 0) {
        mag = '停用'
        status = 1
      } else {
        mag = '启用'
        status = 0
      }

      this.$confirm(mag + '该方案?', '操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axiosput(
          `operation/advancedScheme/status?id=${row.id}&status=${status}`
        ).then((res) => {
          if (res.data.status === '10000') {
            this.getTableData()
            this.$message.success(`${mag}成功！`)
          }
        })
      })
    },
    deleteMsg(row) {
      this.$confirm('删除该条数据?', '删除操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axiosdelete('operation/advancedScheme', {
          params: {
            advancedSchemeId: row.id
          }
        }).then((res) => {
          if (res.data.status == 10000) {
            this.$message.success('删除成功!')
            this.getTableData()
          }
        })
      })
    }
  },
  mounted() {
    this.getTableData()
    this.getOptions()
  }
}
</script>

<style>
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/warningManage/warningPlan/index.vue